import { Image } from '@cue/atoms';
import { Video, VideoTypes } from '@cue/molecules';
import { Modal, Slider, useModal } from '@cue/organisms';
import { LocalStorageUtil } from '@cue/utility';
import { useMediaAnalytics } from '@project/hooks/use-media-analytics';
import { useCallback, useMemo, useState } from 'react';
import {
  CMS_Content_Module_VideoSliderData,
  CMS_Content_Module_VideoSliderDataVideo,
} from './types';
export type VideoSliderProps = CMS_Content_Module_VideoSliderData;

export const VideoSlider = (props: VideoSliderProps) => {
  const { videos, player_type = 'VideoSlider' } = props;
  const STORAGE_SELECTOR = 'seenVideos';
  const localSeenVideos: string | null = LocalStorageUtil.get(STORAGE_SELECTOR);
  const [currentPlayingVideo, setCurrentPlayingVideo] =
    useState<CMS_Content_Module_VideoSliderDataVideo>();
  const [activeIndex, setActiveIndex] = useState(0);
  const [seenVideos, setSeenVideos] = useState<string[]>(
    localSeenVideos ? JSON.parse(localSeenVideos) : [],
  );
  const [slideModal] = useModal();

  const onVideoClick = useCallback(
    (video: CMS_Content_Module_VideoSliderDataVideo) => {
      setCurrentPlayingVideo(video);
      slideModal.current?.open();

      setTimeout(() => {
        document.querySelector('video')?.addEventListener('webkitendfullscreen', () => {
          slideModal.current?.close();
        });
        const updatedVideos = !seenVideos.includes(video.id)
          ? [...seenVideos, video.id]
          : seenVideos;
        setSeenVideos(updatedVideos);
        LocalStorageUtil.set(STORAGE_SELECTOR, JSON.stringify(updatedVideos));
      }, 500);
    },
    [seenVideos, slideModal],
  );

  const slider = useMemo(
    () => (
      <Slider
        onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
        className="cue-grid-slider cue-video-slider"
        spaceBetween={10}
        initialSlide={activeIndex}
        slidesPerView={3}
        slidesPerGroup={3}
        breakpoints={{
          769: {
            spaceBetween: 28,
            slidesPerView: 6,
            slidesPerGroup: 6,
          },
        }}
        pagination={{ enabled: true, clickable: true }}>
        {videos.map((v) => {
          return (
            <div
              className={`cue-video-slider-element ${seenVideos.includes(v.id) ? 'cue-video-slider-element-seen' : ''}`}
              key={v.id}>
              <button
                onClick={() => onVideoClick(v)}
                type="button"
                className="cue-video-slider-element-play">
                <Image src="/theme/siemens/icons/play-icon.png" />
              </button>
              <Image src={v.poster.src} srcSet={v.poster.srcSet} />
            </div>
          );
        })}
      </Slider>
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [seenVideos, videos],
  );
  return (
    <div>
      {slider}

      <Modal
        ref={slideModal}
        overrideCSS={{
          '.cue-modal-content': { width: '90vw', maxWidth: 1280, background: 'transparent' },
          '.cue-modal-close-button-wrapper': { right: '10px !important', top: '10px !important' },
        }}>
        {currentPlayingVideo ? (
          <Video
            {...{
              playing: true,
              url: currentPlayingVideo.src,
              poster: currentPlayingVideo.poster.src,
            }}
            useMediaAnalytics={useMediaAnalytics}
            trackingTitle={currentPlayingVideo.title}
            videoType={VideoTypes.VoD}
            trackingType={player_type}
          />
        ) : (
          <></>
        )}
      </Modal>
    </div>
  );
};
